import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { temayiBaslat } from './Hesap';
// Önce marka belirteçleri, sonra ekranın kendi biçimi: `styles.css` içindeki her renk
// buradaki değişkenlerden okunuyor. Sıra ters olsaydı ilk çizimde tanımsız değişkenler
// kullanılırdı. Dosya üretilmiş: `npm run marka:getir` (bkz. scripts/marka-getir.mjs).
import './marka.css';
import './styles.css';
import './crm-tonlar.css';

// Saklanan tema seçimi ilk çizimden önce uygulanıyor; sonra uygulanırsa ekran bir an titrer.
temayiBaslat();

const container = document.getElementById('root');
if (!container) throw new Error('root container missing');
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
